import { render, staticRenderFns } from "./ViewPrevious.vue?vue&type=template&id=fdcf76a8&scoped=true&"
import script from "./ViewPrevious.vue?vue&type=script&lang=js&"
export * from "./ViewPrevious.vue?vue&type=script&lang=js&"
import style0 from "./ViewPrevious.vue?vue&type=style&index=0&id=fdcf76a8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdcf76a8",
  null
  
)

export default component.exports